/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import { ApolloClient, InMemoryCache, NormalizedCacheObject } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { BatchHttpLink } from '@apollo/client/link/batch-http';

interface ClientConfig {
	uri: string;
	getToken: () => string | null;
}

export type ApolloClientCustom = ApolloClient<NormalizedCacheObject>;

// eslint-disable-next-line max-len
export default function createGraphQlClient({ uri, getToken }: ClientConfig): ApolloClientCustom {
	const link = new BatchHttpLink({
		uri,
		batchMax: 5,
		batchInterval: 25,
		fetch,
	});

	const authLink = setContext((_, { headers }) => {
		const token = getToken();
		return {
			headers: {
				...headers,
				authorization: token ? `Bearer ${token}` : '',
			},
		};
	});

	return new ApolloClient<NormalizedCacheObject>({
		uri,
		cache: new InMemoryCache({ addTypename: false }),
		link: authLink.concat(link),
	});
}
